import { useEffect, useState } from "react";

/*
 * Monitors the window.eqxObj object for a specific key. Returns the value of the key when it is set.
 *
 * window.eqxObj["key"] = "value";
 */
const useEqxObj = (key, timeout = 0) => {
  const [isLoading, setIsLoading] = useState(timeout > 0);
  const [value, setValue] = useState(null);

  useEffect(() => {
    window.eqxObj = window.eqxObj || {};

    let isMounted = true;
    let timeoutId;

    if (!key) {
      setIsLoading(false);
    } else {
      let defaultValue;

      if (window.eqxObj[key]) {
        defaultValue = window.eqxObj[key];
        setValue(defaultValue);
        setIsLoading(false);
      } else {
        timeoutId = setTimeout(() => {
          setIsLoading(false);
        }, timeout);
      }

      Object.defineProperties(window.eqxObj, {
        ["_" + key]: {
          configurable: true,
          value: defaultValue,
          writable: true,
        },
        [key]: {
          configurable: true,
          get() {
            return this["_" + key];
          },
          set(newValue) {
            this["_" + key] = newValue;

            if (isMounted) {
              clearTimeout(timeoutId);
              setValue(newValue);
              setIsLoading(false);
            }
          },
        },
      });
    }

    return () => {
      clearTimeout(timeoutId);
      isMounted = false;
    };
  }, [key, timeout]);

  return {
    isLoading,
    value,
  };
};

export default useEqxObj;
